
import {merge as observableMerge, fromEvent as observableFromEvent,  BehaviorSubject ,  Observable } from 'rxjs';

import {map, debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { ConfigurationService } from './../../shared/configuration.service';
import { AuthenticationService } from './../../shared/authentication.service';
import { QualityTicketService } from './../../shared/qualityticketqueue.service';
import { Component, ElementRef, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { MatSnackBar } from  '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';






import { DatePipe } from '@angular/common'
import { TicketService } from '../../shared/ticketService';
import { QACompletedTicket } from '../../shared/qaTicket';
import { elementAt } from '../../../../../node_modules/rxjs/operator/elementAt';

@Component({
  selector: "app-evaluatequalityqueue",
  templateUrl: "./evaluatequalityqueue.component.html",
  styleUrls: ["./evaluatequalityqueue.component.scss"]
})

export class EvaluatequalityqueueComponent implements OnInit {
  screen = false;
  isDataAvailable = false;
  displayedColumns = ['takenby', 'qualityTicketStart', 'qualityTicketCompletion','gcTakenBy', 'ticketNumber'];
  dataChange: BehaviorSubject<QACompletedTicket[]> = new BehaviorSubject<QACompletedTicket[]>([]);
  get data(): QACompletedTicket[] { return this.dataChange.value; }
  dataSource: EvaluateQualityQueueDataSource | null;
  public errormessage: string | null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filter: ElementRef;

  activity: string = "";
  href: string = "";

  constructor(private qualityQueueService: QualityTicketService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private auth: AuthenticationService,
    public router: Router,
    public route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public ticketService: TicketService,
    public datepipe: DatePipe,
    public configurationService: ConfigurationService) {
  }

  populateConfigurationQueue(activity: string) {
    this.ticketService.getActivityTickets(activity, this.auth.currentState).subscribe(result => {
      this.dataChange.next(result);
      this.isDataAvailable = true;
      this.cdRef.detectChanges();
      this.initSource();
    });
  }


  ngOnInit() {
    this.href = this.router.url;
    if(this.href.toLowerCase().includes('evaluate')){
      this.activity = 'evaluate';
    }
    if(this.href.toLowerCase().includes('dispute')){
      this.activity = 'dispute';
    }
    this.populateConfigurationQueue(this.activity);
  }

  initSource() {
    this.dataSource = new EvaluateQualityQueueDataSource(this, this.paginator, this.sort);
    observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.dataSource) { return; }
        this.dataSource.filter = this.filter.nativeElement.value;
      });
    this.cdRef.detectChanges();
  }
}



export class EvaluateQualityQueueDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  dataChange: BehaviorSubject<QACompletedTicket[]> = new BehaviorSubject<QACompletedTicket[]>([]);
  get data(): QACompletedTicket[] { return this.dataChange.value; }

  filteredData: QACompletedTicket[] = [];
  renderedData: QACompletedTicket[] = [];

  constructor(private rcgcomponent: EvaluatequalityqueueComponent,
    private _paginator: MatPaginator,
    private _sort: MatSort) {
    super();

    this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<QACompletedTicket[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.rcgcomponent.dataChange,
      this._sort.sortChange,
      this._filterChange,
      this._paginator.page,
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      // Filter data
      
        this.filteredData = this.rcgcomponent.data.slice().filter((item: QACompletedTicket) => {
            const searchStr = (item.QualityCompletedBy + item.GCTicketNumber).toLowerCase();
        return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
      });
    

      // Sort filtered data
      const sortedData = this.sortData(this.filteredData.slice());

      // Grab the page's slice of the filtered sorted data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
      return this.renderedData;
    
    }));
  
  }

  disconnect() { }

  /** Returns a sorted copy of the database data. */
  sortData(data: QACompletedTicket[]): QACompletedTicket[] {
    if (!this._sort.active || this._sort.direction === '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'takenby': [propertyA, propertyB] = [a.QualityCompletedBy, b.QualityCompletedBy]; break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}
